import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@mui/styles";
import { compose } from "recompose";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import { injectIntl } from "react-intl";
import ProfileHeader from "./ProfileHeader";
import EstateSelectToolbar from "../../components/EstateSelectToolbar";
import AppBar from "./../../components/DefaultAppBar";
import {
  withCurrentUser,
  withCurrentEstate,
  withEstates,
} from "../../functions/hocs";
import FolderList from "../../components/Common/FolderList";
import { fullAddress } from "../../functions/users";

/**
 *
 */
const route = "/profile/my-data";

/**
 *
 * @param {*} data
 */
const getEstatesContent = (data) => {
  return (data || []).map((document) => ({
    name: document.name,
    address: fullAddress(document.address),
    propertyManagementId: document.propertyManagementId,
  }));
};

/**
 *
 */
const AllMyEstatesInformation = injectIntl((props) => (
  <FolderList
    // subheader="Angaben zu ihren Wohneinheiten"
    data={getEstatesContent(props.data)}
  >
    {(document, index) => (
      <ListItem key={`${index}-${document.id}`}>
        <ListItemText primary={document.name} />
      </ListItem>
    )}
  </FolderList>
));

/**
 *
 */
function MyDataContainer(props) {
  const {
    classes,
    intl: { formatMessage },
    currentEstate,
    estates,
  } = props;

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <EstateSelectToolbar noTicketFilter />
      </AppBar>

      <ProfileHeader estate={currentEstate} />

      <Typography variant="h6" className={classes.title} align="center">
        {formatMessage({ id: "profile.my_data.title.subtitle" })}
      </Typography>

      <ul>
        <li>
          <Typography variant="subtitle1" className={classes.title}>
            {formatMessage({ id: "profile.my_data.current_estates" })}
          </Typography>

          <AllMyEstatesInformation data={[currentEstate]} />
        </li>
        <li>
          <Typography variant="subtitle1" className={classes.title}>
            {formatMessage({ id: "profile.my_data.all_available_estates" })}
          </Typography>

          <AllMyEstatesInformation data={estates} />
        </li>
      </ul>
    </div>
  );
}

MyDataContainer.route = route;

const styles = (theme) => ({
  title: {
    marginTop: theme.spacing(2),
  },
  center: {
    display: "flex",
    margin: "50% auto",
    fontSize: "10rem",
  },
  button: {
    width: "100%",
  },
});

export default compose(
  withRouter,
  injectIntl,
  withCurrentUser(),
  withCurrentEstate(),
  withEstates(),
  withStyles(styles),
)(MyDataContainer);
